import localeText from '../../../../locales/datagrid'
import { SwitchSelect } from '@/global/components/SwitchSelect'
import {
    GridFilterItemPro,
    GridFilterModelPro,
    LinkOperator,
} from '../utils/filterModelPro'
import React from 'react'

export default function FieldLinkOperator({
    item,
    onFilterModelChange,
    className,
}: {
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    return (
        <SwitchSelect
            label="Lógica"
            variant="outlined"
            options={[
                {
                    value: LinkOperator.And,
                    label: localeText.filterPanelOperatorAnd,
                },
                {
                    value: LinkOperator.Or,
                    label: localeText.filterPanelOperatorOr,
                },
            ]}
            value={item.linkOperator || LinkOperator.And}
            className={className}
            onChange={valor => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id ? { ...p, linkOperator: valor } : p,
                    ),
                }))
            }}
        />
    )
}
